import React, { useCallback } from 'react';

import { useNavigateWithCheckUser } from '@interlayer/js/app/hooks/navigate/useNavigate/useNavigateWithCheckUser';
import { openWindow } from '@interlayer/js/utils/url.util';

import { TViewModeConfig, VIEW_ALL_LINK_ACTIONS } from '../types';

export const useHandlerViewAllActionClick = ({
    setViewMode,
    config
}: {
    config: TViewModeConfig;
    setViewMode: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const navigate = useNavigateWithCheckUser();

    return useCallback(() => {
        switch (config.linkAction) {
            case VIEW_ALL_LINK_ACTIONS.internalLink: {
                navigate(config.internalLinkUrl);
                break;
            }
            case VIEW_ALL_LINK_ACTIONS.externalLink: {
                openWindow(config.externalLinkUrl, '_blank');
                break;
            }

            case VIEW_ALL_LINK_ACTIONS.changeViewMode: {
                setViewMode(prevState => !prevState);
                break;
            }

            default: {
                setViewMode(prevState => !prevState);
            }
        }
    }, [config.externalLinkUrl, config.internalLinkUrl, config.linkAction, navigate, setViewMode]);
};
